const externalUse = {
    path: 'externalUse',
    name: 'externalUse',
    component: () => import('@/views/externalUse'),
    redirect: 'noRedirect',
    hidden: true,
    meta: {
        //externalUse is fake code
        code: 'externalUse',
        showRealm: ['COMMON'],
        icon: 'HSIconfont hs-icon-file',
    },
    children: [
        {
            name: 'orgEpdConfig',
            path: 'orgEpdConfig',
            component: () => import('@/views/externalUse/epdConfig/index.vue'),
            meta: { code: 'organization:organization:epdConfig,All-Star' }
        },
        {
            name: 'storeEpdConfig',
            path: 'storeEpdConfig',
            component: () => import('@/views/externalUse/epdConfig/index.vue'),
            meta: { code: 'organization:terminals:epdConfig,All-Star' }
        },
    ]
};
export default externalUse;